"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spain = void 0;
exports.Spain = {
    id: 'spain',
    companyName: 'Spain',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: false,
        realm: 'spain',
    },
    isInternal: true,
    isActive: true,
    countries: ['ES'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3BhaW4uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvU3BhaW4udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxLQUFLLEdBQVU7SUFDeEIsRUFBRSxFQUFFLE9BQU87SUFDWCxXQUFXLEVBQUUsT0FBTztJQUNwQixjQUFjLEVBQUUsQ0FBQyxLQUFLLENBQUM7SUFDdkIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLEtBQUs7UUFDbEIsS0FBSyxFQUFFLE9BQU87S0FDakI7SUFDRCxVQUFVLEVBQUUsSUFBSTtJQUNoQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=